<template>
  <Projects
    no-filter
    tab
    :query="{ batteryId: battery.id }"
    :limit="5"
  ></Projects>
</template>

<script>
import Projects from "@/components/Projects/index.vue";
export default {
  components: { Projects },
  props: {
    battery: {
      type: Object,
    },
  },
};
</script>

<style></style>
